import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import type { IssueType } from '../../../common/types';

type Props = {
	value: IssueType;
};

const IssueTypePickerReadOnly = ({ value }: Props) => (
	<Box xcss={wrapperStyles}>
		<Tooltip content={value.name} position="top">
			<img height="16" width="16" src={value.iconUrl} alt={value.name} />
		</Tooltip>
	</Box>
);

export default IssueTypePickerReadOnly;

const wrapperStyles = xcss({
	padding: 'space.050',
});
